import { useEffect, useState } from 'react';

// "controllers"
import { SwipeGameController } from 'controllers';

// components
import { Carousel, CarouselImage } from 'shared/components/bulma/carousel';

// assets
import ImagePlaceholder from "assets/placeholder.png";

const SwipeGameImage = ({ imageId }) => {
    const [image, setImage] = useState(ImagePlaceholder);

    useEffect(() => {
        const getImage = async () => {
            const data = await SwipeGameController.getImageById(imageId);

            if (data) {
                setImage(data.url);
            }
        }

        getImage();
    }, [imageId]);

    if (!image) {
        return null;
    }

    return <CarouselImage imgSrc={image} className="is-1by1" />;
}

const SwipeGameView = ({ id, imageIds }) => {

    if (!imageIds.length) {
        return (
            <div className="container">
                <p>No images found!</p>
            </div>
        )
    }

    return (
        <Carousel id={id}>
            {imageIds.map((image, index) => (
                <SwipeGameImage key={`image-${index}`} imageId={image} />
            ))}
        </Carousel>
    );
};

export { SwipeGameView };
